<template>
  <div>
    <ContentHeader title="Add New Configuration" />
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-primary">
              <form @submit.prevent="handleCreateData()">
                <div class="card-body">
                  <div class="form-group">
                    <label for="name">Agent Level</label>
                    <select class="form-select" name="ib_level" :class="{ 'border-danger': $v.payload.ib_level.$error }"
                      v-model="payload.ib_level">
                      <option selected disabled>Select Agent Level</option>
                      <option v-for="value_data in databenar" :key="value_data.ib_level" :value="value_data.ib_level">
                        {{ value_data.ib_label }}
                        <!-- <template v-if="value_data.ib_label == 'INTRODUCING_BROKER'">Agent Level</template>
<template v-else-if="value_data.ib_label == 'PARTNER_IB'">Supervisor Area</template>
<template v-else-if="value_data.ib_label == 'MASTER_IB'">Manager Area</template> -->
                      </option>
                      <!-- <option value="PARTNER_IB">PARTNER IB</option>
                      <option value="INTRODUCING_BROKER">
                        Agent
                      </option> -->
                      <div class="text-danger" v-if="$v.payload.ib_level.$error">
                        <small>Agent Level Required</small>
                      </div>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="min_investor">Min Investor</label>
                    <input type="number" class="form-control" id="min_investor" placeholder="Input Min Investor"
                      v-model="payload.min_investor" :class="{
                        'border-danger':
                          $v.payload.min_investor.$error ||
                          !$v.payload.min_investor.numeric,
                      }" />
                    <div class="text-danger" v-if="
                      $v.payload.min_investor.$error &&
                      !$v.payload.min_investor.required
                    ">
                      <small>Min Investor Required</small>
                    </div>
                    <div class="text-danger" v-if="!$v.payload.min_investor.numeric">
                      <small>This Field must be a Number</small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="min_deposit">Min Deposit ($)</label>
                    <input type="number" class="form-control" id="min_deposit" placeholder="Input Min Deposit"
                      v-model="payload.min_deposit" :class="{
                        'border-danger': $v.payload.min_deposit.$error,
                      }" />
                    <div class="text-danger" v-if="
                      $v.payload.min_deposit.$error &&
                      !$v.payload.min_deposit.required
                    ">
                      <small>Min Deposit Required</small>
                    </div>
                    <div class="text-danger" v-if="!$v.payload.min_deposit.numeric">
                      <small>This Field must be a Number</small>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="p-1">
                    <button type="submit" href="#" class="btn btn-danger btn-block mr-1" :disabled="isDisabled">
                      Add Configuration
                    </button>
                  </div>
                  <div class="p-1">
                    <router-link :to="{ name: 'ListConfiguration' }" class="btn btn-outline-danger btn-default ml-1">
                      Cancel
                    </router-link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import apiClient from "@/services/ApiServices";
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      payload: {
        ib_level: "",
        min_investor: "",
        min_deposit: "",
      },

      IBOptions: [
        {
          ib_level: 'MASTER_IB',
          ib_label: 'Manager Area'
        },
        {
          ib_level: 'PARTNER_IB',
          ib_label: 'Supervisor Area'
        },
        {
          ib_level: 'INTRODUCING_BROKER',
          ib_label: 'Agent Level'
        }
      ],
      dataoke: [],
      ib_config_records: [],
      databenar: [],
      masukdataa: '',
      isDisabled: false,
    };
  },
  created() {
    document.title = "Add Configuration - Manager Cabang";
  },

  components: {
    ContentHeader,
  },
  validations: {
    payload: {
      ib_level: {
        required,
      },
      min_investor: {
        required,
        numeric,
      },
      min_deposit: {
        required,
        numeric,
      },
    },
  },
  mounted() {
    apiClient.get(
      `configurations?corporate_partner_id=${this.$user_id}`
    ).then((response) => {
      this.dataoke = response.data.data
      this.loadIBOptions()
    })
  },
  methods: {

    loadIBOptions() {
      // hanya sediakan opsi jika level belum ada
      // ambil data dari config
      apiClient.get(
        `configurations?corporate_partner_id=${this.$user_id}`
      ).then((response) => {

        this.ib_config_records = response.data.data
        if (this.ib_config_records.length < 1) {
          // belum ada config di database, return semua opsi
          this.databenar = this.IBOptions
        } else {
          // reset opsi
          // filter opsi yang sudah ada di config database
          this.databenar = []

          let filtered_options = this.IBOptions.filter(option => {
            let found = false
            for (const level_config of this.ib_config_records) {
              if (option.ib_level == level_config.ib_level) {
                found = true
              }
            }
            // only return the one not matching
            if (!found) return true
          })
          this.databenar = filtered_options

        }
        // set default option to first row
        this.payload.ib_level = this.databenar[0].ib_level
      })
    },

    async handleCreateData() {
      const data = new FormData();

      data.append("corporate_partner_id", parseInt(this.$user_id));
      data.append("ib_level", this.payload.ib_level);
      data.append("min_investor", this.payload.min_investor);
      data.append("min_deposit", this.payload.min_deposit);

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";

        try {
          await apiClient.post("/configurations/", data);
          this.submitStatus = "OK";
          this.$swal(
            "Added!",
            "New Configuration has been added.",
            "success"
          ).then(() => {
            this.$router.push({ name: "ListConfiguration" });
          });
        } catch (e) {
          this.$swal("Fail!", e.data.data.ib_level[0], "error");
          this.submitStatus = "ERROR";
        }
      }
    },
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
